import * as React from 'react';
export const SelectItemContext = /*#__PURE__*/React.createContext(undefined);
export function useSelectItemContext() {
  const context = React.useContext(SelectItemContext);
  if (context === undefined) {
    throw new Error('Base UI: SelectItemContext is missing. SelectItem parts must be placed within <Select.Item>.');
  }
  return context;
}